<template>
  <v-app>
    <v-app-bar app color="black" dark class="d-flex justify-end">
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.xsOnly" @click="showDrawer = true"
      />

      <v-spacer></v-spacer>
      <div id="navigation-bar" v-if="$vuetify.breakpoint.smAndUp">
        <router-link to="/home">
          <v-btn text @click="goToHome" x-large>
            Home
          </v-btn>
        </router-link>

        <router-link to="/gallery">
          <v-btn text @click="goToGallery" x-large>
            Galleria
          </v-btn>
        </router-link>

        <v-btn text @click="scrollToContatti" x-large>
          Contatti
        </v-btn>
      </div>


    </v-app-bar>

    <v-navigation-drawer v-model="showDrawer" temporary app>

      <span class="nav-title d-block text-center mt-5">Arte & Arte</span>
      <span class="nav-subtitle d-block text-center mb-2">F.lli Regonesi</span>

      <v-list class="nav-list">
          <router-link to="/home">
            <v-list-item @click="goToHome">
              HOME
            </v-list-item>
          </router-link>


        <router-link to="/gallery">
          <v-list-item @click="goToGallery">
            GALLERIA
          </v-list-item>
        </router-link>
        <v-list-item @click="scrollToContatti">
          CONTATTI
        </v-list-item>
      </v-list>

    </v-navigation-drawer>

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-footer color="black" class="white--text footer">
      <v-row class="flex-column flex-sm-row justify-center align-center">
        <span class="mx-5 my-3">
          2021
        </span>
        <span class="mx-5 my-3">
          P.IVA - 04344470168
        </span>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      showDrawer: false,
      tab: 'home'
    }
  },
  created() {
    this.$store.dispatch('loadGallery')
  },
  methods: {
    goToHome() {
      this.showDrawer = false
      window.scrollTo({ top: 0 })
      if (this.$route.path !== "/home") {
        this.$router.push("/home")
      }
    },
    goToGallery() {
      this.showDrawer = false
      window.scrollTo({ top: 0 })
      if (this.$route.path !== '/gallery') {
        this.$router.push("/gallery")
      }
    },
    scrollToContatti() {
      this.showDrawer = false
      if (this.$route.path !== "/home") {
        this.$router.push("/home").then(() => {
          document.getElementById("contatti").scrollIntoView({
            behavior: "smooth"
          });
        })
      } else {
        document.getElementById("contatti").scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Patrick+Hand&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Itim&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@500&display=swap');

#navigation-bar {
  font-family: 'Itim', cursive;
  width: fit-content;
}

.footer {
  font-family: 'Itim', cursive;

}

.nav-list {
  font-family: 'Itim', cursive;
}

.nav-title {
  font-family: 'Itim', cursive;
  font-size: 1.5rem;
}

.nav-subtitle {
  font-family: 'Itim', cursive;
  font-size: 1.2rem;
}

html {
  scroll-behavior: smooth;
}

a {
  text-decoration: none;
}

</style>